<template>
  <div class="py-4">
    <div class="d-flex align-center pt-4">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#006341"
            v-bind="attrs"
            v-on="on"
            @click="$router.go(-1)"
            icon
            ><v-icon>mdi-reply</v-icon></v-btn
          >
        </template>
        <span>Back</span>
      </v-tooltip>
      <h3 class="ml-2">Update Bank Data</h3>
    </div>
    <div
      v-if="loading"
      class="rounded_max mt-5 d-flex align-center justify-center"
    >
      <v-card
        class="_temp_list pa-4 rounded_max mt-5 justify-center"
        style="height: 72vh"
        flat
      >
        <v-skeleton-loader max-width="100%" type="article"></v-skeleton-loader>
        <v-skeleton-loader max-width="100%" type="article"></v-skeleton-loader>
      </v-card>
    </div>
    <div
      v-if="!loading && dataSet"
      class="rounded_max mt-5 d-flex align-center justify-center"
      flat
    >
      <v-card
        class="_temp_list pa-4 rounded_max mt-5 d-flex flex-column align-center justify-center"
        flat
      >
        <div class="pa-2">
          <h2 class="mb-8">Data Scholar</h2>
        </div>
        <v-row no-gutters align="start" justify="center" class="pa-3">
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Scholarship</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              hide-details
              :items="optScholarship"
              item-text="txt"
              item-value="val"
              placeholder="Choose Scholarship"
              v-model="dataSet.scholarship"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Scholar Name</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              label="Scholar Name"
              dense
              placeholder="Write scholar name in here..."
              hide-details
              color="green"
              v-model="dataSet.name"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Email</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              type="email"
              label="Email"
              dense
              placeholder="Write email in here..."
              hide-details="auto"
              color="green"
              v-model="dataSet.email"
              :rules="emailRules"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">NIK</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              type="number"
              label="NIK"
              dense
              placeholder="Write nik in here..."
              hide-details
              color="green"
              v-model="dataSet.nik"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Gender</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-radio-group
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              v-model="dataSet.gender"
              hide-details
              class="ma-0"
              dense
              row
            >
              <v-radio label="Male" color="green" value="Male"></v-radio>
              <v-radio label="Female" color="green" value="Female"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Year PTN</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              type="number"
              label="Year PTN"
              :ruler="yearRules"
              dense
              placeholder="Write year ptn in here..."
              color="green"
              v-model="dataSet.year_ptn"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">University</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              :items="optUniv"
              item-text="name"
              item-value="id"
              v-model="dataSet.university"
              placeholder="Choose University"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Program</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              placeholder="Write program in here..."
              label="Program"
              hide-details
              color="green"
              v-model="dataSet.program"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Phone Number</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              type="number"
              dense
              label="Phone Number"
              placeholder="Write phone number in here..."
              hide-details
              color="green"
              v-model="dataSet.phone_number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">WhatsApp Number</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              type="number"
              dense
              label="WhatsApp Number"
              placeholder="Write whatsapp number in here..."
              hide-details
              color="green"
              v-model="dataSet.wa_number"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Address</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-textarea
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              name="input-7-1"
              label="Address"
              v-model="dataSet.address"
              rows="3"
              auto-grow
            ></v-textarea>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Province</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              :items="optProvinces"
              item-text="name"
              item-value="id"
              v-model="dataSet.province"
              @change="fetchDataRegencies"
              placeholder="Choose Provinces"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">City</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              :items="optRegencies"
              item-text="name"
              item-value="id"
              v-model="dataSet.city"
              @change="fetchDataDistrict"
              placeholder="Choose Regencies"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Village</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              :items="optDistrict"
              item-text="name"
              item-value="id"
              v-model="dataSet.village"
              @change="fetchDataVillage"
              placeholder="Choose Village"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Country</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Country"
              placeholder="Write country in here..."
              hide-details
              color="green"
              v-model="dataSet.country"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Post Code</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Post Code"
              placeholder="Write post code in here..."
              hide-details
              color="green"
              v-model="dataSet.post_code"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Date of Birth</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-menu
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              v-model="showPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :disabled="
                    permissions.includes('UPCM') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                      ? false
                      : true
                  "
                  v-model="dataSet.dob"
                  prepend-inner-icon="mdi-calendar-range"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataSet.dob"
                @input="closeDateMenu"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Birth Place</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Birth Place"
              placeholder="Write birth place in here..."
              hide-details
              color="green"
              v-model="dataSet.birth_place"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Religion</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-select
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              hide-details
              :items="optReligion"
              item-text="txt"
              item-value="val"
              placeholder="Choose Religion"
              v-model="dataSet.religion"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Etnic</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Etnic"
              placeholder="Write etnic in here..."
              hide-details
              color="green"
              v-model="dataSet.etnic"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Grouping Faculty</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Grouping Faculty"
              placeholder="Write grouping faculty in here..."
              hide-details
              color="green"
              v-model="dataSet.grouping_faculty"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Major</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Major"
              placeholder="Write major in here..."
              hide-details
              color="green"
              v-model="dataSet.major"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Faculty</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'SUPERADMIN' ||
                role == 'VENDOR'
                  ? false
                  : true
              "
              dense
              label="Faculty"
              placeholder="Write faculty in here..."
              hide-details
              color="green"
              v-model="dataSet.faculty"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Akun Sosial Media</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <div class="scope_lang">
              <v-row
                v-for="(item, idx) in akun_sosial_media"
                :key="`sosmed-${idx}`"
              >
                <v-col cols="3">
                  {{ item.name }}
                </v-col>
                <v-col cols="9">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    v-model="item.value"
                    hide-details="auto"
                    :placeholder="item.name"
                    required
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Education History</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <div class="scope_lang">
              <div
                v-for="(item, idx) in historical_edu"
                class="mb-3"
                :key="`pres-${idx}`"
              >
                <v-text-field
                  :disabled="
                    permissions.includes('UPCM') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                      ? false
                      : true
                  "
                  v-model="item.val"
                  hide-details="auto"
                  :placeholder="`Education ${idx + 1}`"
                  required
                  dense
                ></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Achievement</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <div class="scope_lang">
              <div
                v-for="(item, idx) in achievement"
                class="mb-3"
                :key="`pres-${idx}`"
              >
                <v-text-field
                  :disabled="
                    permissions.includes('UPCM') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                      ? false
                      : true
                  "
                  v-model="item.val"
                  hide-details="auto"
                  :placeholder="`Achievement ${idx + 1}`"
                  required
                  dense
                ></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Organization activity</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <div class="scope_lang">
              <div
                v-for="(item, idx) in orgs_activity"
                class="mb-3"
                :key="`pres-${idx}`"
              >
                <v-text-field
                  :disabled="
                    permissions.includes('UPCM') ||
                    role == 'SUPERADMIN' ||
                    role == 'VENDOR'
                      ? false
                      : true
                  "
                  v-model="item.val"
                  hide-details="auto"
                  :placeholder="`Organization activity ${idx + 1}`"
                  required
                  dense
                ></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="my-2">
            <div class="pa-2">
              <p class="medium_txt">Language Ability</p>
            </div>
          </v-col>
          <v-col cols="12" md="8" class="my-2">
            <div
              class="scope_lang"
              v-for="(item, idx) in language_ability"
              :key="`val${idx}`"
            >
              <v-row>
                <v-col cols="4"> Bahasa </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item.bahasa"
                    placeholder="Bahasa"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> Memiliki Sertifikasi </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item['Memiliki Sertifikasi']"
                    placeholder="Memiliki Sertifikasi "
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> Jenis Tes </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item['Jenis Tes']"
                    placeholder="Jenis Tes"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> Skor </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item.Skor"
                    placeholder="Skor"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> Tahun Sertifikat </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item['Tahun Sertifikat']"
                    placeholder="Tahun Sertifikat"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> No. Sertifikat </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item['No. Sertifikat']"
                    placeholder="No. Sertifikat"
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> Nama Lembaga Bahasa </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item['Nama Lembaga Bahasa']"
                    placeholder="Nama Lembaga Bahasa "
                    required
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="4"> Masa Berlaku </v-col>
                <v-col cols="8">
                  <v-text-field
                    :disabled="
                      permissions.includes('UPCM') ||
                      role == 'SUPERADMIN' ||
                      role == 'VENDOR'
                        ? false
                        : true
                    "
                    hide-details="auto"
                    v-model="item['Masa Berlaku']"
                    placeholder="Masa Berlaku"
                    required
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col
            cols="12"
            class="d-flex justify-end"
            v-if="
              permissions.includes('UPCM') ||
              role == 'VENDOR' ||
              role == 'SUPERADMIN'
            "
          >
            <v-btn color="success" @click="updateData">
              <h4 v-if="!loading">Update Data</h4>
              <h4 v-if="loading">Loading...</h4>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "listBankData",
  components: {},
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      showPicker: false,
      optProvinces: [],
      optRegencies: [],
      optDistrict: [],
      optVillage: [],
      optUniv: [],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v,
          ) || "E-mail must be valid",
      ],
      akun_sosial_media: [
        {
          name: "Instagram",
          value: "",
        },
        {
          name: "Linkedin",
          value: "",
        },
        {
          name: "Facebook",
          value: "",
        },
        {
          name: "Youtube",
          value: "",
        },
        {
          name: "Twitter",
          value: "",
        },
      ],
      historical_edu: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      achievement: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      orgs_activity: [
        {
          val: "",
        },
        {
          val: "",
        },
        {
          val: "",
        },
      ],
      language_ability: [
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
        {
          bahasa: "",
          "Memiliki Sertifikasi": "",
          "Jenis Tes": "",
          Skor: "",
          "Tahun Sertifikat": "",
          "No. Sertifikat": "",
          "Nama Lembaga Bahasa": "",
          "Masa Berlaku": "",
        },
      ],
      optScholarship: [
        { txt: "NCS", val: "NCS" },
        { txt: "Sayap Garuda", val: "Sayap Garuda" },
        { txt: "Special Initiative", val: "Special Initiative" },
      ],
      optReligion: [
        { txt: "Islam", val: "islam" },
        { txt: "Katolik", val: "katolik" },
        { txt: "Konghucu", val: "konghucu" },
        { txt: "Kristen", val: "kristen" },
        { txt: "Hindu", val: "hindu" },
        { txt: "Buddha", val: "buddha" },
      ],
      yearRules: [
        (v) => !!v || "Year is required",
        (v) => (v && v.length <= 50) || "Year must be less than 50 characters",
      ],
    };
  },
  mounted() {
    this.dataUniv();
    this.fetchDataProvince();
    this.fetchData();
  },
  methods: {
    closeDateMenu() {
      this.showPicker = false;
      this.selectedDate = this.date
        ? moment(this.date).format("dddd, MMMM Do YYYY")
        : "";
    },
    dataUniv() {
      let data = {
        path: `manage/univ/get`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optUniv = data.data;
          this.optUniv.forEach((item) => {
            item.id = item.id.toString();
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/bank-data?filter[id]=${this.$route.params.idBankData}`,
      };
      this.$store
        .dispatch("gudang/getData", data)
        .then(async (data) => {
          this.dataSet = data.data[0];
          if (this.dataSet.province) {
            await this.fetchDataRegencies(this.dataSet.province);
          }
          if (this.dataSet.city) {
            await this.fetchDataDistrict(this.dataSet.city);
          }
          this.loading = false;
          if (this.dataSet.province) {
            this.dataSet.province = parseInt(this.dataSet.province);
          }
          if (this.dataSet.city) {
            this.dataSet.city = parseInt(this.dataSet.city);
          }
          if (this.dataSet.village) {
            this.dataSet.village = parseInt(this.dataSet.village);
          }

          if (this.dataSet["historical_edu"] != null) {
            let tempData = JSON.parse(this.dataSet["historical_edu"]);

            tempData.forEach((el, index) => {
              if (el) {
                this.historical_edu[index]["val"] = el;
              }
            });
          }
          if (this.dataSet["achievement"] != null) {
            let tempData = JSON.parse(this.dataSet["achievement"]);
            tempData.forEach((el, index) => {
              if (el) {
                this.achievement[index]["val"] = el;
              }
            });
          }
          if (this.dataSet["orgs_activity"] != null) {
            let tempData = JSON.parse(this.dataSet["orgs_activity"]);
            tempData.forEach((el, index) => {
              if (el) {
                this.orgs_activity[index]["val"] = el;
              }
            });
          }
          if (this.dataSet["acc_socmed"] != null) {
            let tempData = JSON.parse(this.dataSet["acc_socmed"]);
            tempData.forEach((el) => {
              if (el) {
                for (let j = 0; j < this.akun_sosial_media.length; j++) {
                  if (el.name == this.akun_sosial_media[j]["name"]) {
                    this.akun_sosial_media[j]["value"] = el.value;
                  }
                }
              }
            });
          }
          if (this.dataSet["language_ability"] != null) {
            let tempData = JSON.parse(this.dataSet["language_ability"]);
            tempData.forEach((el, index) => {
              if (el) {
                this.language_ability[index]["bahasa"] = el.bahasa;
                this.language_ability[index]["Memiliki Sertifikasi"] =
                  el["Memiliki Sertifikasi"];
                this.language_ability[index]["Jenis Tes"] = el["Jenis Tes"];
                this.language_ability[index]["Skor"] = el["Skor"];
                this.language_ability[index]["Tahun Sertifikat"] =
                  el["Tahun Sertifikat"];
                this.language_ability[index]["No. Sertifikat"] =
                  el["No. Sertifikat"];
                this.language_ability[index]["Nama Lembaga Bahasa"] =
                  el["Nama Lembaga Bahasa"];
                this.language_ability[index]["Masa Berlaku"] =
                  el["Masa Berlaku"];
              }
            });
          }
          this.total = data.total;
          this.last_page = data.last_page;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    updateData() {
      this.loading = true;
      let historical_edu = [];
      this.historical_edu.forEach((el) => {
        historical_edu.push(el.val);
      });
      let achievement = [];
      this.achievement.forEach((el) => {
        achievement.push(el.val);
      });
      let orgs_activity = [];
      this.orgs_activity.forEach((el) => {
        orgs_activity.push(el.val);
      });
      let body = {
        id: this.$route.params.idBankData,
        scholarship: this.dataSet.scholarship,
        name: this.dataSet.name,
        email: this.dataSet.email,
        nik: this.dataSet.nik,
        gender: this.dataSet.gender,
        year_ptn: this.dataSet.year_ptn,
        university: this.dataSet.university,
        program: this.dataSet.program,
        phone_number: this.dataSet.phone_number,
        wa_number: this.dataSet.wa_number,
        address: this.dataSet.address,
        province: this.dataSet.province,
        city: this.dataSet.city,
        village: this.dataSet.village,
        country: this.dataSet.country,
        post_code: this.dataSet.post_code,
        dob: this.dataSet.dob,
        birth_place: this.dataSet.birth_place,
        religion: this.dataSet.religion,
        etnic: this.dataSet.etnic,
        grouping_faculty: this.dataSet.grouping_faculty,
        major: this.dataSet.major,
        faculty: this.dataSet.faculty,
        acc_socmed: JSON.stringify(this.akun_sosial_media),
        historical_edu: JSON.stringify(historical_edu),
        achievement: JSON.stringify(achievement),
        orgs_activity: JSON.stringify(orgs_activity),
        language_ability: JSON.stringify(this.language_ability),
      };
      let data = {
        path: `manage/bank-data/update`,
        body: body,
      };

      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
          this.$router.go(-1);
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.error = e.message;
          this.loading = false;
        });
    },
    fetchDataProvince() {
      let data = {
        path: `region/province`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optProvinces = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchDataRegencies(item) {
      let data = {
        path: `region/regency?province_id=${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optRegencies = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchDataDistrict(item) {
      let data = {
        path: `region/district?regency_id=${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.optDistrict = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
    fetchDataVillage(item) {
      let data = {
        path: `region/village?district_id  =${item}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then(async (data) => {
          this.optVillage = data;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style></style>
